"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "primary": "#0055ff",
    "primary-hover": "#0040e6",
    "primary-container": "#eaf2ff",
    "primary-container-alpha": "rgba(0, 85, 255, 0.08)",
    "primary-container-hover": "#d1e3ff",
    "primary-container-hover-alpha": "rgba(0, 85, 255, 0.16)",
    "on-primary": "#fff",
    "on-primary-container": "#0040e6",
    "on-secondary": "#1a1a1a",
    "on-secondary-inversed": "#fff",
    "secondary-alpha": "rgba(26, 26, 26, 0.05)",
    "secondary-container-alpha": "rgba(26, 26, 26, 0.1)",
    "secondary-inverse-alpha": "rgba(255, 255, 255, 0.1)"
};
// Path: src/tokens/colors/interaction.ts
//# sourceMappingURL=interaction.js.map